import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpAuthService } from '../common/services/authentication.service';
import { StartupService } from '../common/services/startup.service';
import { applicationContentConfig } from '../configs/config-internal-content';
import { session } from '../common/session/session';
import { map } from 'rxjs/operators';
import { BrandService } from '../common/services/brand-service';
import { AdobeAnalyticsScriptService } from '../adobe-analytics/services/adobe-analytics-script.service';
import { AdobeAnalyticsService } from '../adobe-analytics/services/adobe-analytics.service';
import { constants } from '../configs/config-internal-constants';
import { cahootHeader } from '../configs/config-internal-cahoot-header-content';
import { EventTrackerSnippetScriptService } from '../event-tracker/event-tracker-snippet-script.service';
import { HeaderControl, SessionTimeoutComponent } from 'ui-common-components-angular';
import { ContactUsComponent } from '../contact-us/contact-us.component';
import { FooterComponent } from '../common/footer/footer.component';
import { TealiumScriptService } from 'src/app/tealium-script/tealium-script.service';

@Component({
    selector: 'olb-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    imports: [HeaderControl, ContactUsComponent, FooterComponent, SessionTimeoutComponent]
})
export class HomeComponent implements OnInit, AfterViewInit {
  public navigationLinks = applicationContentConfig.headerUrls;
  public navigationCahootLinks = cahootHeader.headerCahootUrls;
  public dataLoaded = false;
  public userAuthenticated = false;
  public host: string;
  private message: string;
  public isCahoot = false;
  public loadCss: string;

  // Default logos
  public logos = {
    pngImageName: constants.SANTANDER_LOGO_PNG,
    svgImageName: constants.SANTANDER_LOGO_SVG,
  };

  // Cahoot Default logos
  public cahootLogos = {
    pngImageName: 'cahoot_logo.png',
    svgImageName: 'cahoot_logo.svg',
  };

  // Mobile logos
  public mobileLogos = {
  };

  constructor(
    private startupService: StartupService,
    private httpAuthService: HttpAuthService,
    private brandService: BrandService,
    private adScript: AdobeAnalyticsScriptService,
    private readonly adobeAnalyticsService: AdobeAnalyticsService,
    private readonly eventTrackerService: EventTrackerSnippetScriptService,
    private readonly tealiumService: TealiumScriptService,
    private readonly router: Router
  ) { }

  ngOnInit(): void {
    this.isCahoot = this.brandService.isCahoot();
    this.host = this.startupService.host;
    this.startupService.isAuthenticated().subscribe((response) => {
      this.userAuthenticated = response;
    });
    if (this.brandService.isRetail()) {
      this.callCustomerProfile();
      this.eventTrackerService.initialize();
    } else {
      this.dataLoaded = true;
    }
    this.loadCss = 'desktop-brand-logo';
  
  }

  setAltTextCahootLogo() {
     const cahootAltText = 'Cahoot';
      const apply = ()=>{
        const logos = document.querySelectorAll<HTMLImageElement>('#santander-logo');
        logos.forEach((logo) => {
          logo.setAttribute('alt', cahootAltText);
        });
        const link =  document.getElementById('santander-logo');
        if (link) {
          link.setAttribute('title', cahootAltText);
        }
      };
      setTimeout(apply, 0);
  }

  ngAfterViewInit(): void {
    if (this.isCahoot){
      this.setAltTextCahootLogo();
    }
    this.adScript
      .initialize()
      .then((response) => {
        if (this.brandService.isRetail()) {
          this.adobeAnalyticsService.setSubsection('retail');
          switch (session.segment) {
            case 'private': {
              this.adobeAnalyticsService.setSegment(
                constants.ADOBE_PRIVATE_BANKING
              );
              this.tealiumService.trackEvent(constants.ADOBE_PRIVATE_BANKING);
              break;
            }
            case 'select': {
              this.adobeAnalyticsService.setSegment(constants.ADOBE_SELECT);
              this.tealiumService.trackEvent(constants.ADOBE_SELECT);
              break;
            }
            default: {
              this.adobeAnalyticsService.setSegment(
                constants.ADOBE_MASS_MARKET
              );
              this.tealiumService.trackEvent(constants.ADOBE_MASS_MARKET);
              break;
            }
          }
        } else if (this.brandService.isSbbi()) {
          this.adobeAnalyticsService.setSubsection('business');
           this.tealiumService.trackEvent('business');
          this.adobeAnalyticsService.setSegment(constants.BRAND_SBBI);
          this.tealiumService.trackEvent(constants.BRAND_SBBI);
        } else if (this.brandService.isCahoot()) {
          this.adobeAnalyticsService.setSubsection('retail');
          this.tealiumService.trackEvent('retail');
          this.adobeAnalyticsService.setSegment(constants.BRAND_CAHOOT);
          this.tealiumService.trackEvent(constants.BRAND_CAHOOT);
        }
        this.adobeAnalyticsService.setPage('contact-details');
        this.tealiumService.trackEvent('contact-details');
        this.adobeAnalyticsService.pageLoaded();
      })
      .catch((errorMessage) => {
        console.error(errorMessage);
      });
  }
  
  callCustomerProfile() {
    const url =
      this.host +
      this.startupService.customerProfile.replace('{{uid}}', session.uid);
    this.httpAuthService
      .httpApiCall(url)
      .pipe(
        map((data) => {
          session.segment = data.segmentName.trim().toLowerCase();
          switch (session.segment) {
            case 'private': {
              this.logos = {
                pngImageName: 'santander-pb-logo.png',
                svgImageName: 'santander-pb-logo.svg',
              };
              this.mobileLogos = {
                pngImageName: 'santander-pb-logo-mobile.png',
                svgImageName: 'santander-pb-logo-mobile.png'
              }
              break;
            }
            case 'select': {
              this.logos = {
                pngImageName: 'santander-select-logo.png',
                svgImageName: 'santander-select-logo.svg',
              };
              this.mobileLogos = {
                pngImageName: 'santander-select-logo_mobile.png',
                svgImageName: 'santander-select-logo_mobile.png'

              }
              break;
            }
            default: {
              this.logos = {
                pngImageName: constants.SANTANDER_LOGO_PNG,
                svgImageName: constants.SANTANDER_LOGO_SVG,
              };
              this.mobileLogos = {
                pngImageName: constants.SANTANDER_LOGO_PNG,
                svgImageName: constants.SANTANDER_LOGO_SVG,
              }
              break;
            }
          }
        })
      )
      .subscribe(
        (response: any) => {
          this.dataLoaded = true;
        },
        (error) => {
          const msgRep = {
            error,
          };
          // this.loggingService.warn('W4PEP',msgRep);
          this.logos = {
            pngImageName: constants.SANTANDER_LOGO_PNG,
            svgImageName: constants.SANTANDER_LOGO_SVG,
          };
          this.mobileLogos = {
            pngImageName: constants.SANTANDER_LOGO_PNG,
            svgImageName: constants.SANTANDER_LOGO_SVG,
          }
          this.dataLoaded = true;
        }
      );
  }

  
  // changed logOff url
  onClickHeaderTextLinks(event) {
    this.message = event;

    if (!this.isCahoot) {
      this.httpAuthService.revokeAccessToken(session.accessToken).subscribe(
        (response) => {
          switch (this.message) {
            case constants.SANTANDER_LOGO_TXT:
            case 'link_0':
              this.startupService.navigateByUrl(
                this.host + applicationContentConfig.bksAccountUrl
              );
              break;
            case 'link_1':
              this.startupService.navigateByUrl(
                this.host + applicationContentConfig.contactUsUrl
              );
              break;
            case 'link_2':
              this.startupService.logout(
                applicationContentConfig.externalSantanderLogoff
              );
              break;
          }
        },
        (error) => {
          switch (this.message) {
            case constants.SANTANDER_LOGO_TXT:
            case 'link_0':
              this.startupService.navigateByUrl(
                this.host + applicationContentConfig.bksAccountUrl
              );
              break;
            case 'link_1':
              this.startupService.navigateByUrl(
                this.host + applicationContentConfig.contactUsUrl
              );
              break;
            case 'link_2':
              this.startupService.logout(
                applicationContentConfig.externalSantanderLogoff
              );
              break;
          }
        }
      );
    } else {
      switch (this.message) {
        case constants.SANTANDER_LOGO_TXT:
        case 'link_0':
          this.startupService.navigateByUrl(
            this.host + applicationContentConfig.bksAccountUrl
          );
          break;
        case 'link_1':
          this.startupService.navigateByUrl(
            this.host + applicationContentConfig.contactUsUrl
          );
          break;
        case 'link_2':
          this.startupService.logout(
            applicationContentConfig.externalCahootLogOffUrl
          );
          break;
      }
    }

  }
}
